import { Injectable } from '@angular/core';
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import {ApiScopeDto, CreateEditApiScopeDto} from "./models/ApiScopeDtos";
import { HttpClient } from "@angular/common/http";
import {CrudSettings, QueryParams} from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

class ApiScopeCrudSettings implements CrudSettings<string, ApiScopeDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix: string | undefined;
  deleteSuffix: string | undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editMethod: "PUT" | "PATCH" = 'PATCH';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix: string | undefined;
  getListSuffix = 'all';
  getSuffix: string | undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';

  idGetter(entity: ApiScopeDto): string {
    return entity.id
  }

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);

    return {params: dict}
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/IdentityServer/ApiScope';
  }
}

@Injectable({
  providedIn: null
})
export class ApiScopeDataService extends BasePagedCrudService<string, ApiScopeDto, CreateEditApiScopeDto, CreateEditApiScopeDto>{

  constructor(http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(http, new ApiScopeCrudSettings(environmentService), dialogService)
  }
}
